import type { ComponentProps } from 'react'
import { SurveyComponentFlow } from '@coorum-research/core/src/components/SurveyComponentFlow'

type Props = Omit<ComponentProps<typeof SurveyComponentFlow>, 'surveyCompleteDisabled'> & {
  getCurrentSurveyCompleteDisabled: () => boolean
}

/**
 * currentSurveyCompleteDisabledAtomの値の変更を監視し、SurveyComponentFlowに渡す
 * re-render防止のため、wrapper componentを作成
 */
export function SurveyComponentFlowWithState({
  getCurrentSurveyCompleteDisabled,
  ...props
}: Props) {
  const currentSurveyCompleteDisabled = getCurrentSurveyCompleteDisabled()

  return (
    <SurveyComponentFlow
      {...props}
      surveyCompleteDisabled={currentSurveyCompleteDisabled}
    />
  )
}
